
import { defineComponent, onMounted, ref, watch } from 'vue'
import { getRevisionInfo } from '@/api/profile'
import TermTab from '@/components/profile/revise/termTab.vue'
import ContextTab from '@/components/profile/revise/conceptTab.vue'
import { useRoute } from 'vue-router'
import { Revise } from '@/api/type'

export default defineComponent({
  components: { ContextTab, TermTab },
  setup() {
    const route = useRoute()
    const tabsIndex = ref(1 as number)
    const reviseData = ref([] as Revise[])
    const activeIndex = ref(0 as number)

    const switchTabs = (key: number) => {
      tabsIndex.value = key
    }
    const openTerm = (index: number) => {
      tabsIndex.value = 1
      activeIndex.value = index
    }
    watch(reviseData, () => {
      if (activeIndex.value > reviseData.value.length - 1) {
        activeIndex.value = 0
      }
    })
    const addZero = (num: number) => (num < 10 ? `0${num}` : num)
    const formatDate = (now: number) => {
      const time = new Date(now)
      const year = time.getFullYear()
      const month = time.getMonth() + 1
      const date = time.getDate()
      return `${year}-${addZero(month)}-${addZero(date)}`
    }
    const handleBnTimeState = (item) => {
      item.submitTime = formatDate(
        parseInt(item.biosBnCommentBoList[0].timestamp)
      )
      item.timesTamp = item.biosBnCommentBoList[0].timestamp
      item.submitState = item.biosBnCommentBoList[0].state
      return item
    }
    const handleHeadTimeState = (item) => {
      item.submitTime = formatDate(
        parseInt(item.biosHeadCommentBoList[0].timestamp)
      )
      item.timesTamp = item.biosHeadCommentBoList[0].timestamp
      item.submitState = item.biosHeadCommentBoList[0].state
      return item
    }
    const handleConcept = (val) => {
      val.timesDate = formatDate(parseInt(val.timestamp))
      val.broaderNarrow = []
      if (val.addBroaderConcepts) {
        val.addBroaderConcepts.forEach((item) => {
          val.broaderNarrow.push({ radio: '-1', text: item })
        })
      }
      if (val.addNarrowConcepts) {
        val.addNarrowConcepts.forEach((item) => {
          val.broaderNarrow.push({ radio: '1', text: item })
        })
      }
      return val
    }
    const initReviseInfo = async () => {
      const result = await getRevisionInfo()
      if (result) {
        result.forEach((item) => {
          if (item.biosBnCommentBoList && item.biosHeadCommentBoList) {
            if (
              item.biosBnCommentBoList[0].timestamp >
              item.biosHeadCommentBoList[0].timestamp
            ) {
              handleBnTimeState(item)
            } else {
              handleHeadTimeState(item)
            }
            item.biosBnCommentBoList.forEach((data) => {
              handleConcept(data)
            })
            item.biosHeadCommentBoList.forEach((data) => {
              data.timesDate = formatDate(parseInt(data.timestamp))
              data.nonBioConcept = data.nonBioConcept !== 0
            })
          } else if (item.biosBnCommentBoList) {
            handleBnTimeState(item)
            item.biosBnCommentBoList.forEach((data) => {
              handleConcept(data)
            })
          } else if (item.biosHeadCommentBoList) {
            handleHeadTimeState(item)
            item.biosHeadCommentBoList.forEach((data) => {
              data.timesDate = formatDate(parseInt(data.timestamp))
              data.nonBioConcept = data.nonBioConcept !== 0
            })
          }
          result.sort((a, b) => (b.timesTamp < a.timesTamp ? -1 : 1))
        })
        reviseData.value = result
      }
    }
    onMounted(() => {
      initReviseInfo()
      if (route.params.tabsNumber === '2') {
        tabsIndex.value = Number(route.params.tabsNumber)
      } else if (route.params.tabsNumber === '1') {
        tabsIndex.value = Number(route.params.tabsNumber)
      }
    })
    return {
      route,
      tabsIndex,
      activeIndex,
      switchTabs,
      reviseData,
      initReviseInfo,
      openTerm,
    }
  },
})
